import LinkHasExpiredPage from "./LinkHasExpiredPage"

export default LinkHasExpiredPage
